import Users from './Users';
import reducer from './reducer';
import './Users.scss';

export {
    reducer,
};

export default Users